import React, { useEffect, useRef, useState } from "react";
import { FaLock } from "react-icons/fa6";

const Slide2 = ({ onNext, onBack }) => {
  const [formData, setFormData] = useState({
    street: "",
    unit: "",
    city: "",
    state: "",
    zipCode: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const [errors, setErrors] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const streetInputRef = useRef(null);
  const unitInputRef = useRef(null);
  const cityInputRef = useRef(null);
  const zipcodeInputRef = useRef(null);
  const stateInputRef = useRef(null);

  useEffect(() => {
    const { street, city, state, zipCode } = formData;
    const isStreetValid = !street || /^[a-zA-Z0-9\s,.'-]{3,}$/.test(street);
    const isCityValid = !city || /^[a-zA-Z\s,.'-]{2,}$/.test(city);
    const isStateValid = !state || /^[a-zA-Z\s,.'-]{2,}$/.test(state);
    const isZipCodeValid = zipCode.trim() !== "";

    setIsFormValid(
      street &&
        city &&
        state &&
        zipCode &&
        isStreetValid &&
        isCityValid &&
        isStateValid &&
        isZipCodeValid
    );

    setErrors({
      street: street && !isStreetValid ? "Please enter a valid street address" : "",
      city: city && !isCityValid ? "Please enter a valid city" : "",
      state: state && !isStateValid ? "Please enter a valid state" : "",
      zipCode: zipCode && !isZipCodeValid ? "Please enter a zip code" : "",
    });
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (showErrors) setShowErrors(false);
  };
  const handleButtonClick = (e) => {
    const { street, city, state, zipCode } = formData;

    const newErrors = {};
    if (!street) {
      newErrors.street = "Please enter your street address";
    }
    if (!city) {
      newErrors.city = "Please enter your city";
    }
    if (!state) {
      newErrors.state = "Please enter your state";
    }
    if (!zipCode || zipCode.trim() === "") {
      newErrors.zipCode = "Please enter your zip code";
    }

    if (Object.keys(newErrors).length > 0) {
      e.preventDefault();
      setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
      setShowErrors(true);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      const addressString = `${formData.street}${formData.unit ? ', ' + formData.unit : ''}, ${formData.city}, ${formData.state} ${formData.zipCode}`;
      const selectedAddress = {
        address: addressString,
        zipCode: formData.zipCode,
      };
      window.scrollTo(0, 0);
      onNext("manualAddress", selectedAddress);
      // window.scrollTo(0, 0);
      // onNext("manualAddress", formData);
    } else {
      const firstInvalidField = Object.keys(errors).find((key) => errors[key]);
      if (firstInvalidField) {
        document.getElementById(firstInvalidField).focus();
      }
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="step-section">
          <h1>No worries. Let's try it this way</h1>
        </div>
        <div className="field-mini-wrap">
          <div className="row">
            <div className="col-md-7">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    showErrors && errors.street ? "invalid-field" : ""
                  }`}
                  placeholder="Enter a street"
                  name="street"
                  value={formData.street}
                  ref={streetInputRef}
                  id="street"
                  pattern="^[a-zA-Z0-9\s,.'-]{3,}$"
                  onChange={handleInputChange}
                  aria-invalid={showErrors && !!errors.street}
                />
                <label htmlFor="street">Street</label>
              </div>
              {showErrors && errors.street && (
                <div className="field-error-message">{errors.street}</div>
              )}
            </div>
            <div className="col-md-5">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input`}
                  placeholder="Enter a Apt/Unit"
                  name="unit"
                  value={formData.unit}
                  ref={unitInputRef}
                  id="unit"
                  onChange={handleInputChange}
                />
                <label htmlFor="unit">Apt/Unit</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    showErrors && errors.city ? "invalid-field" : ""
                  }`}
                  placeholder="Enter a city"
                  name="city"
                  value={formData.city}
                  ref={cityInputRef}
                  id="city"
                  pattern="^[a-zA-Z\s,.'-]{2,}$"
                  onChange={handleInputChange}
                  aria-invalid={showErrors && !!errors.city}
                />
                <label htmlFor="city">City</label>
              </div>
              {showErrors && errors.city && (
                <div className="field-error-message">{errors.city}</div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    showErrors && errors.state ? "invalid-field" : ""
                  }`}
                  placeholder="Enter a state"
                  name="state"
                  value={formData.state}
                  ref={stateInputRef}
                  id="state"
                  pattern="^[a-zA-Z\s,.'-]{2,}$"
                  onChange={handleInputChange}
                  aria-invalid={showErrors && !!errors.state}
                />
                <label htmlFor="state">State</label>
              </div>
              {showErrors && errors.state && (
                <div className="field-error-message">{errors.state}</div>
              )}
            </div>
            <div className="col-md-7">
              <div className="input-container form-floating position-relative input-box">
                <input
                  className={`form-control input-field pac-target-input ${
                    showErrors && errors.zipCode ? "invalid-field" : ""
                  }`}
                  type="text"
                  placeholder="Enter a zip code"
                  name="zipCode"
                  value={formData.zipCode}
                  id="zipCode"
                  ref={zipcodeInputRef}
                  aria-invalid={showErrors && !!errors.zipCode}
                  onChange={handleInputChange}
                  inputMode="numeric"
                  required
                />
                <label htmlFor="zipCode">Zip code</label>
              </div>
              {showErrors && errors.zipCode && (
                <div className="field-error-message">{errors.zipCode}</div>
              )}
            </div>
          </div>
        </div>
        <div className="lock-bg">
          <FaLock className="lock-color" />
          <span className="from-lock">Your information is fully secure.</span>
        </div>
        <button type="submit" className={`btn btn-next
          ${
            !isFormValid
              ? "button-disabled"
              : ""
          }
          `}
          onClick={handleButtonClick}>
          Next
        </button>
        <input type="hidden" id="progress_slide_1" data-width="15%"/>
      </form>
    </div>
  );
};

export default Slide2;
